function InputFunctional (props){
    return(
        <h3 className = "fromInput">Entered text: <p><i>{props.value}</i></p></h3>
    )
}

export default InputFunctional;